export function setTabParam(id) {
    const params = new URLSearchParams(window.location.search);
    params.set('tab', id);
    const search = params.toString();
    const url = `${window.location.pathname}?${search}`;
    window.history.replaceState({}, '', url);
}
